import React from "react";
import { X } from "lucide-react";
import { Rating } from "@mui/material";
import "../store/Fsn29CoachSelections.css";
import { useNavigate } from "react-router-dom";


const Fsn19ViewProfile = ({ onTap }) => {
  console.log("coach:", onTap.FAI);

  const navigate = useNavigate();

  const handleBackButtonPress = () => {
    if (window.Android) {
      window.Android.onBackPressed();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        {/* Close Button */}
        <X className="w-6 h-6 cursor-pointer" onClick={handleBackButtonPress} />
      </div>

      {/* Profile Content */}
      <div className="flex flex-col items-center px-4 py-8">
        {/* Profile Image */}
        <div className="coach-profile-logo">
          {onTap.FAI?.coachImage ? (
            <img
              src={onTap.FAI.coachImage}
              alt="Coach profile"
              className="coach-profile img"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-gray-600">No Image</span>
            </div>
          )}
        </div>

        {/* Name and Title */}
        <h1 className="text-2xl font-semibold mb-1">
          {onTap.FAI?.coachName || "Coach Name"}
        </h1>
        <p className="text-gray-600 mb-2">
          {onTap.FAI?.professionalheadline || "Professional Title"}
        </p>

        {/* Rating */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Rating value={onTap.FAI?.rating || 0} precision={0.5} readOnly />
          <span>{onTap.FAI?.rating || 0}</span>
        </div>

        {/* About Section */}
        <div className="w-full mb-8">
          <h2 className="text-xl font-bold mb-4">ABOUT ME</h2>
          <p className="text-gray-700 leading-relaxed">
            {onTap.FAI?.aboutMe || "No information available"}
          </p>
        </div>

        {/* Certifications Section */}
        <div className="w-full">
          <h2 className="text-xl font-bold mb-4">CERTIFICATIONS</h2>
          <ul className="list-none">
            {onTap.FAI?.certifications &&
            onTap.FAI.certifications.length > 0 ? (
              onTap.FAI.certifications.map((cert, index) => (
                <li key={index} className="text-gray-700 mb-2">
                  {cert.title} ({cert.startDate} to {cert.endDate})
                </li>
              ))
            ) : (
              <li className="text-gray-700 mb-2">
                No certifications available
              </li>
            )}
          </ul>
        </div>

        {/* Specialities Section */}
        <div className="w-full">
          <h2 className="text-xl font-bold mb-4">SPECIALITIES</h2>
          <ul className="list-none">
            {onTap.FAI?.specialities && onTap.FAI.specialities.length > 0 ? (
              onTap.FAI.specialities.map((speciality, index) => (
                <li key={index} className="text-gray-700 mb-2">
                  {speciality.title}
                </li>
              ))
            ) : (
              <li className="text-gray-700 mb-2">
                - No specialities available
              </li>
            )}
          </ul>
        </div>

        {/* Languages Section */}
        <div className="w-full">
          <h2 className="text-xl font-bold mb-4">LANGUAGES</h2>
          <ul className="list-none">
            {onTap.FAI?.languages && onTap.FAI.languages.length > 0 ? (
              onTap.FAI.languages.map((language, index) => (
                <li key={index} className="text-gray-700 mb-2">
                  {language.title}
                </li>
              ))
            ) : (
              <li className="text-gray-700 mb-2">- No Languages available</li>
            )}
          </ul>
        </div>

       
      </div>
    </div>
  );
};

export default Fsn19ViewProfile;
